export default "__VITE_ASSET__BYOrwflA__"